export const consecutiveRuns = (numbers: number[]) => {
  const runs: number[][] = []
  for (const number of [...numbers].sort((one, other) => one - other)) {
    const run = runs[runs.length - 1]
    if (run && run[run.length - 1] === number - 1) run.push(number)
    else runs.push([number])
  }
  return runs
}
